<template>
    <div :class="{'v31-input not-empty':value,'v31-input':!value}">
        <label v-html="inputTitle" v-if="value"></label>
        <input ref="input"
            v-model="value"
            :value="value"
            @input="$emit('input', $event.target.value)"
            :type="(inputType?inputType:'text')"
            :name="inputName"
            :autocomplete="autocomplete"
            :placeholder="inputTitle">
    </div>
</template>
<script>
var Inputmask = require('inputmask');
export default {
    props: ['inputName','inputType','inputTitle','value','required','inputMask','autocomplete'],
    data(){
        return {
        }
    },
	methods: {
	},
	mounted: function() {
        if(typeof this.inputMask === 'object') {
            var im = new Inputmask(this.inputMask);
            im.mask(this.$refs.input);
        }
	},
}
</script>

<style>
.v31-input {
    display: block;
    margin:0 0 5px;
    width:100%;
    box-sizing: border-box;
    font-size: 0;
    position: relative;
    border: 1px solid #ddd;
    background:#fff;
}
.v31-input input{
    font-size: 16px;
    display: block;
    width:100%;
    box-sizing: border-box;
    background: none;
    border: none;
    padding: 5px 10px;
}

.v31-input input:focus {
    outline:0;
}

.v31-input.not-empty input {
    padding: 15px 10px 5px;
}

.v31-input label {
    font-size: 11px;
    color: #777;
    background: none;
    position: absolute;
    left:10px;
    top:0;
}
</style>